const DocumentList = async () =>
    import('../../pages/documents/View').then((module) => ({
        Component: module.LogisticManagementDocumentsView,
    }));

const getDocumentRoutes = () => {
    return [
        {
            paths: ['/documents/', '/documents/:tab/'],
            lazy: DocumentList,
        },
    ];
};

export { getDocumentRoutes };
